import {
  AfterContentInit,
  Component,
  computed,
  ContentChildren,
  ElementRef,
  HostListener,
  inject,
  input,
  OnChanges,
  OnDestroy,
  QueryList,
  Renderer2,
  signal,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SideMenuItemChild } from '../side-menu-item/side-menu-item-child/side-menu-item-child.component';

@Component({
  selector: 'app-side-menu-item-group',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './side-menu-item-group.component.html',
  styleUrls: ['./side-menu-item-group.component.css'],
})
export class SideMenuItemGroup
  implements AfterContentInit, OnChanges, OnDestroy
{
  @ContentChildren(SideMenuItemChild) children:
    | QueryList<SideMenuItemChild>
    | undefined;
  @ViewChild('childrenContainer', { static: true })
  childrenContainer!: ElementRef<HTMLDivElement>;

  isOpen = signal<boolean>(false);
  showFlyout = signal<boolean>(false);

  icon = input.required<string>();
  label = input.required<string>();
  active = input<boolean>(false);
  collapsed = input<boolean>(false);

  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private flyoutWrapper: HTMLElement | null = null;

  /** 인라인 하위 메뉴 표시 여부 */
  isInlineVisible = computed(() => !this.collapsed() && this.isOpen());

  ngOnChanges() {
    this.isOpen.set(this.active());
    if (!this.collapsed()) {
      this.closeFlyout();
    }
  }

  ngAfterContentInit() {
    setTimeout(() => {
      if (this.children && this.children.length > 0) {
        this.children.map(child => {
          if (child.active()) {
            this.isOpen.set(true);
          }
        });
      }
    }, 50);
  }

  ngOnDestroy() {
    this.closeFlyout();
  }

  handleClick(event: MouseEvent) {
    if (this.collapsed()) {
      if (this.showFlyout()) {
        this.closeFlyout();
      } else {
        this.openFlyout(event.currentTarget as HTMLElement);
      }
    } else {
      this.isOpen.set(!this.isOpen());
    }
  }

  private openFlyout(button: HTMLElement) {
    this.closeFlyout();

    const rect = button.getBoundingClientRect();
    const container = this.childrenContainer.nativeElement;

    // body 레벨에 flyout wrapper 생성
    const wrapper = this.renderer.createElement('div') as HTMLElement;
    wrapper.className = 'flyout-overlay';
    wrapper.style.position = 'fixed';
    wrapper.style.top = `${rect.top - 4}px`;
    wrapper.style.left = `${rect.right + 8}px`;
    wrapper.style.zIndex = '9999';

    // children container를 flyout으로 이동
    container.classList.remove('hidden');
    container.className = 'flyout-container';
    wrapper.appendChild(container);
    document.body.appendChild(wrapper);
    this.flyoutWrapper = wrapper;

    this.showFlyout.set(true);
  }

  private closeFlyout() {
    if (this.flyoutWrapper && this.childrenContainer) {
      const container = this.childrenContainer.nativeElement;
      // 다시 원래 위치로 이동
      container.className = 'relative flex flex-col w-full gap-1';
      container.classList.add('hidden');
      this.el.nativeElement
        .querySelector('.menu-group')
        ?.appendChild(container);
      this.flyoutWrapper.remove();
      this.flyoutWrapper = null;
    }
    this.showFlyout.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.showFlyout()) return;
    const clickedInside = this.el.nativeElement.contains(event.target);
    const clickedFlyout = this.flyoutWrapper?.contains(event.target as Node);
    if (!clickedInside && !clickedFlyout) {
      this.closeFlyout();
    }
  }
}
